<template>

<app-content :loading="is.loading && !is.initialised">

	<app-content-head :tabs="tabs" title="Browse" subtitle="Browse and filter all scheduled events.">

	</app-content-head>

	<app-events-filter :filter="filter" :references="references" />

	<app-events v-on:hide="load" :loading="is.loading && is.initialised" :filter="filter" :collection="collection" :columns="columns" :pagination="pagination" :total="total" placeholder="Sorry, no events found." v-on:scrolled="onScrollLoad" />

</app-content>

</template>

<script>

import mixCollection from '@/mixin/collection'

export default {

	mixins: [mixCollection],

	data: function() {

		return {
			scrolling: false,
			endpoint: 'convention/schedule/events',
			live: 'convention/schedule/event',
			filterTemplate: 'events',
			references: {
				times: [],
				days: [],
				lobbies: []
			},
			columns: {
				game: 'auto',
				seats: 100,
				date: 200,
				experience: 100,
				duration: 100,
				location: 200,
				actions: 100
			}
		}

	},

	computed: {

		isCardView: function() {
		
			return this.filter.layout

		},

		query: function() {

			return this.$route.query.search

		},

		tabs: function() {

			return [
				{ name: 'Convention.Schedule.Browse', text: 'All' },
				{ name: 'Convention.Schedule.Browse.Official', text: 'Official' },
				{ name: 'Convention.Schedule.Browse.Teacher', text: 'Teacher Wanted' },
				{ name: 'Convention.Schedule.Browse.Buddies', text: 'Buddies' },
				{ name: 'Convention.Schedule.Browse.Open', text: 'Open' }
			]

		}

	},

	watch: {

		isCardView: function(n) {

			this.scrolling = n

		},

		query: function() {

			this.filter.search = this.$route.query.search
			this.filter.days = [this.$route.query.day]

		}

	},

	methods: {

		onSetupFilter: function() {

			if (this.$route.query.search) this.filter.search = this.$route.query.search
			if (this.$route.query.ticket) this.filter.ticket = this.$route.query.ticket
			if (this.$route.query.day) this.filter.days = [this.$route.query.day]

		}

	}

}

</script>

<style scoped>

</style>